










































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class InvoiceImport extends Vue {
    @Prop({ type: String })
    invoiceName!: string;

    @Prop({ type: Boolean })
    importChange!: boolean;

    @Prop({ type: String })
    endPeriod!: string;

    url: string = ""
    file: any = {};
    param: any = {};
    // 选择模板
    upLoad(e: any) {
        console.log(e);
        if (e.target.files[0]) {
            if (e.target.files[0].size / 1024 / 1024 < 20) {
                this.file = e.target.files[0];
                let data = new FormData();
                // let isProviderOrCustomer = this.importChange ? "0" : "1";
                data.append("file", e.target.files[0]);
                data.append("isProviderOrCustomer", this.importChange ? "0" : "1");
                data.append("accountBookId", this.$store.state.accountBook.id);
                data.append("endPeriod", this.endPeriod);
                data.append("fileName", e.target.files[0].name);
                this.param = data;
            } else {
                this.$message("请选择小于20M的文件");
            }
        }
    }
    // 确定
    async submit() {
        try {
            let res = await Vue.axios.post(`invoice/import`, this.param);
            this.param = {}
            this.file = {}
            this.$emit("finish", true, `导入成功: ${res.data.data}`)
        } catch (e) {
            this.param = {}
            this.file = {}
            this.$emit("finish", false)
        }
    }
    close() {
        this.$emit("close")
    }

}
